import { FormModel } from 'submodules/nerit-framework-ui/common/form-state-manager/types/FormModel'
import { IsOptional } from 'class-validator'
import { CollectionStatusEnum } from 'submodules/nerit-aquatec-sdk/common/enums/CollectionStatusEnum'

export class CollectionCellFormModel extends FormModel {

    @IsOptional()
    status?: CollectionStatusEnum

    @IsOptional()
    note?: string

    constructor(initialData?: Partial<CollectionCellFormModel>) {
        super(initialData)
        Object.assign(this, initialData)
    }

}
